var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.2308C25 15.9652 24.7073 16.6696 24.1864 17.1889C23.6655 17.7083 22.9589 18 22.2222 18H2.77778C2.04107 18 1.33453 17.7083 0.813592 17.1889C0.292658 16.6696 0 15.9652 0 15.2308V12.4615H25V15.2308Z",
    fill: "#CE2028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.53845H25V12.4615H0V5.53845Z",
    fill: "#22408C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 0H2.77778C2.04107 0 1.33453 0.291757 0.813592 0.811089C0.292658 1.33042 0 2.03478 0 2.76923L0 5.53846H25V2.76923C25 2.03478 24.7073 1.33042 24.1864 0.811089C23.6655 0.291757 22.9589 0 22.2222 0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuLogo);
export default __webpack_public_path__ + "static/media/ru-logo.84fd911f00bbb64194dd871637764475.svg";
export { ForwardRef as ReactComponent };